import { useSyncExternalStore } from "react";

import { pwaUpdateStore } from "./pwaUpdateStore";

export function usePwaUpdate() {
  const state = useSyncExternalStore(
    pwaUpdateStore.subscribe,
    pwaUpdateStore.getState,
    () => "none" as const,
  );
  return { state, apply: pwaUpdateStore.apply };
}
